import { render } from "./ConsentTerms.vue?vue&type=template&id=4058ef48"
import script from "./ConsentTerms.vue?vue&type=script&lang=js"
export * from "./ConsentTerms.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__